<svg width="206" height="20">
    @for ( point of points; track point ) {
    <g>
    <rect [attr.x]="point.rect.x"  y="3" width="25" height="15" rx="5" ry="5" stroke-width="4" [attr.fill]="point.rect.fill"/>
    <text class="dataTypeCount" [attr.x]="point.text.x" y="15" [attr.fill]="point.text.stroke" [attr.stroke]="point.text.stroke"><tspan>{{point.text.count}}</tspan></text>
    </g>
    }
</svg>
